export const SET_ENTITIES = 'SET_ENTITIES'
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES'
export const SET_APP_STATUS = 'SET_APP_STATUS'
export const SET_USER_ID = 'SET_USER_ID'
export const SOCKET_ONOPEN = 'SOCKET_ONOPEN'
export const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE'
export const SOCKET_ONERROR = 'SOCKET_ONERROR'
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT'
export const SOCKET_RECONNECT_ERROR = 'SOCKET_RECONNECT_ERROR'
export const SET_AWARDED_DEVICES = 'SET_AWARDED_DEVICES'
export const SET_GEOFENCES = 'SET_GEOFENCES'
export const SET_DEVICES_VIEW = 'SET_DEVICES_VIEW'
export const SET_FOCUS_DEVICE_ID = 'SET_FOCUS_DEVICE_ID'
export const SET_MARKER = 'SET_MARKER'
export const SET_SELECTED_CLASSIFICATION_ID = 'SET_SELECTED_CLASSIFICATION_ID'
export const SET_SELECTED_SERIE_NUMBER = 'SET_SELECTED_SERIE_NUMBER'
export const SET_TRACK_BOUNDS = 'SET_TRACK_BOUNDS'
export const SET_MODE = 'SET_MODE'
export const SET_IS_PLAYBACK_READY = 'SET_IS_PLAYBACK_READY'
export const SET_PLAYBACK_MARKERS = 'SET_PLAYBACK_MARKERS'
export const SET_PREVIOUS_SELECTED_CLASSIFICATION_ID =
    'SET_PREVIOUS_SELECTED_CLASSIFICATION_ID'
export const SET_SHOW_DISTANCE = 'SET_SHOW_DISTANCE'
export const SET_LIST_ORDER_BY = 'SET_LIST_ORDER_BY'
export const SET_AMOUNT_DISTANCE_MARKERS = 'SET_AMOUNT_DISTANCE_MARKERS'
export const SET_REVERT_DISTANCE_MARKERS = 'SET_REVERT_DISTANCE_MARKERS'
export const SET_SHOW_ALL_NAMES = 'SET_SHOW_ALL_NAMES'
export const SET_SHOW_TAILS = 'SET_SHOW_TAILS'
export const SET_IS_MANAGER = 'SET_IS_MANAGER'
export const SET_EVENT_TIMES_DATA = 'SET_EVENT_TIMES_DATA'

